import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SystemMessageService } from '../../../../core/system-message/system-message-service';
import { Subscription } from 'rxjs';
import { TableComponent } from '../../table.component';
import { param } from '../../../http-params';

@Component({
    selector: 'pcg-delete-button',
    templateUrl: './delete-button.component.html',
    styleUrls: ['./delete-button.component.scss'],
    standalone: false
})
export class DeleteButtonComponent<T> implements OnDestroy {
	// URL to send delete request to
	@Input() url: string;
	// The id of the record to delete
	@Input() id: string;
	// Confirmation message
	@Input() confirmMessage = 'Are you sure you want to delete this?';
	// Table for ajax reload
	@Input() table: TableComponent<T>;
	// Can be used to trigger a custom function on delete
	@Output() delete = new EventEmitter<any>();
	// Used to keep track of subscriptions
	subscriptions = new Subscription();

	constructor(private ms: SystemMessageService) {}

	deleteRecord() {
		if (!this.confirmMessage || confirm(this.confirmMessage)) {
			const idQueryStr =
				typeof this.id === 'string' || typeof this.id === 'number'
					? 'id=' + encodeURIComponent(this.id)
					: param(this.id);
			this.subscriptions.add(
				this.ms.getHttpObservable(this, this.url + '?' + idQueryStr).subscribe(obj => {
					this.delete.emit(obj);
					if (this.table) {
						this.table.ajaxReload();
					}
				})
			);
		}
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}
}
